export default {
  name: "CoinsStackedIcon",
  props: {
    width: {
      type: String,
      default: "16"
    },
    height: {
      type: String,
      default: "16"
    },
    color: {
      type: String,
      default: "#757575"
    }
  }
};